import { useMemo } from 'react';
import { addDelimiter } from './string/formatter';

export function formatDataIdAttr(dataId: string = ''): string {
  return dataId
    .replace(/\s/g, '-')
    .replace(/_/g, '-')
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .toLowerCase()
    .trim();
}

export function getDataIdGenerator(prefix = '', constant = '') {
  return function generateDataId(suffix: string) {
    const str = addDelimiter('-', `${prefix}`, `${constant}`, `${suffix}`);
    return formatDataIdAttr(str);
  };
}

export const getDataId =
  (suffix: string) =>
  (prefix = '') =>
  (constant = '') => {
    const str = addDelimiter('-', `${prefix}`, `${constant}`, `${suffix}`);
    return formatDataIdAttr(str);
  };

interface DataIDsContract {
  base: string;
  [key: string]: string;
}

export const getDataIdsFromContract = <T extends DataIDsContract>(
  dataContract: T,
  parentDataId = ''
): Omit<T, 'base'> => {
  const { base, ...dataIdContract } = dataContract;
  const dataIdGenerator = getDataIdGenerator(parentDataId, base);

  return Object.entries(dataIdContract).reduce(
    (result, [key, value]) => ({
      ...result,
      [key]: dataIdGenerator(value)
    }),
    {}
  ) as Omit<T, 'base'>;
};

export const useMemoizedDataIds = <T extends DataIDsContract>(contract: T, parentDataId = '') =>
  useMemo(() => getDataIdsFromContract<T>(contract, parentDataId), [parentDataId, contract]);
